/**
 * Thai 13-digit tax id and the full-tax-invoice buyer form rules.
 * Same check digit as the backend (flowaccountFullTaxInvoice.isValidThaiTaxId):
 * (11 − Σ dᵢ × (13 − i) mod 11) mod 10 over the first 12 digits.
 */
export const normaliseTaxId = (raw: string): string => String(raw || "").replace(/[\s-]/g, "");

export const isValidThaiTaxId = (raw: string): boolean => {
  const digits = normaliseTaxId(raw);
  if (!/^\d{13}$/.test(digits)) return false;
  let sum = 0;
  for (let i = 0; i < 12; i += 1) sum += Number(digits[i]) * (13 - i);
  return (11 - (sum % 11)) % 10 === Number(digits[12]);
};

export interface BuyerFormValues {
  name: string;
  tax_id: string;
  branch_type: "head_office" | "branch";
  branch_no: string;
  address: string;
  zip_code: string;
  phone: string;
  email: string;
}

export type BuyerErrors = Partial<Record<"name" | "tax_id" | "branch" | "address", true>>;

export const validateBuyer = (v: BuyerFormValues): BuyerErrors => {
  const errors: BuyerErrors = {};
  if (!v.name.trim()) errors.name = true;
  if (!isValidThaiTaxId(v.tax_id)) errors.tax_id = true;
  if (v.branch_type === "branch" && !/^\d{5}$/.test(v.branch_no.trim())) errors.branch = true;
  if (!v.address.trim()) errors.address = true;
  return errors;
};
